/**
 * Wrap an async function so concurrent calls share one in-flight promise.
 *
 * This is the single-flight mutex both apps need around token refresh: no
 * matter how many requests hit an expired token at once, exactly one
 * `/auth/refresh` call goes out and every caller settles with its result
 * (all resolve with the same value, or all reject with the same error).
 *
 * @param {Function} fn - Async function to guard
 * @returns {Function} Wrapped function reusing the in-flight promise
 */
export function createSingleFlight(fn) {
  let inflight = null;

  return (...args) => {
    if (inflight) {
      return inflight;
    }

    inflight = Promise.resolve()
      .then(() => fn(...args))
      .finally(() => {
        inflight = null;
      });

    return inflight;
  };
}
